<div oui-dialog-title>
  Purger l'investisseur
  <oui-button
    type="icon"
    oui-dialog-close>
    <oui-icon>close</oui-icon>
  </oui-button>
</div>
<oui-dialog-content [scroll]="true">
  <div class="dialog-content">
    <section class="dialog-intro">
      <div>
        <p class="eyebrow">Investisseur #{{ investorId }}</p>
        <h5>{{ investorLabel }}</h5>
      </div>

      @if (execution()?.isInProgress) {
        <oui-tag
          type="status"
          size="big"
          status="pending">
          Purge en cours
        </oui-tag>
      } @else if (execution()?.statusLevel === 'error') {
        <oui-tag
          type="status"
          size="big"
          status="error">
          Purge non lancée
        </oui-tag>
      } @else if (!execution() && result()) {
        <oui-tag
          type="status"
          size="big"
          [status]="result()?.canPurge ? 'completed' : 'error'">
          {{ result()?.canPurge ? 'Purge possible' : 'Purge bloquée' }}
        </oui-tag>
      } @else if (loading()) {
        <oui-tag
          type="status"
          size="big"
          status="pending">
          Vérification en cours
        </oui-tag>
      }
    </section>

    @if (loading()) {
      <div class="state-message">Vérification de la purge en cours.</div>
    } @else if (error()) {
      <div class="state-message state-message--error">{{ error() }}</div>
    } @else {
      @if (!execution() && result(); as purge) {
        <div class="summary-line">
          <span>{{ purge.blockingIssueCount }} bloquant(s)</span>
          <span>{{ purge.warningCount }} warning(s)</span>
        </div>

        <div class="check-list">
          @for (check of purge.checks; track check.key) {
            <article class="check-item">
              <div class="check-item__heading">
                <div>
                  <strong>{{ check.label }}</strong>
                  <p>{{ check.message }}</p>
                </div>
                <oui-tag
                  type="status"
                  size="big"
                  [status]="getCheckStatus(check)">
                  {{ getCheckSeverityLabel(check) }}
                </oui-tag>
              </div>

              @if (hasFamilyRelations(check)) {
                <div class="family-relation-list">
                  @for (relation of check.familyRelations; track relation.relationId + '-' + relation.relatedInvestorId) {
                    <div class="family-relation">
                      <div class="family-relation__type">{{ formatRelationType(relation.relationTypeCode) }}</div>
                      <dbw-investor-card
                        [id]="relation.relatedInvestorId"
                        [code]="relation.relatedInvestorCode"
                        [name]="relation.relatedInvestorDisplayName"
                        [statusCode]="relation.relatedInvestorStatusCode">
                      </dbw-investor-card>
                    </div>
                  }
                </div>
              }
            </article>
          }
        </div>
      }

      @if (execution(); as purgeExecution) {
        <section class="execution-panel">
          <div>
            <p class="eyebrow">Demande PURGE-RGPD</p>
            <h6>{{ purgeExecution.executionId }}</h6>
          </div>

          @if (purgeExecution.status) {
            <oui-tag
              type="status"
              size="big"
              [status]="purgeExecution.statusLevel">
              {{ purgeExecution.status }}
            </oui-tag>
          }
        </section>
      }

      @if (executionError()) {
        <div class="state-message state-message--error">{{ executionError() }}</div>
      }
    }
  </div>
</oui-dialog-content>

<oui-dialog-actions>
  @if (execution()?.isInProgress) {
    <oui-button oui-dialog-close>Fermer</oui-button>
  } @else if (canExecutePurgeAction()) {
    <oui-button
      iconSuffix="delete"
      [disabled]="!canExecutePurge()"
      (click)="executePurge()">
      {{ executing() ? 'Lancement...' : 'Lancer la purge' }}
    </oui-button>
  }
</oui-dialog-actions>
